<div class="position-relative">
    <div class="d-flex mx-0 flex-column flex-md-row justify-contet-between p-white border-bottom px-4 py-3 secondary-nav" style="position: fixed; top:65px; z-index:5;">
        <div class="d-flex flex-column col">
            <h3 class="mt-0 mb-1">Companies</h3>
            <p-breadcrumb [model]="items"></p-breadcrumb>
        </div>
        <div class="d-flex justify-content-start justify-content-md-end col mt-2 mt-md-0">
            <button pButton type="button" icon="pi pi-plus" label="Add Company" iconPos="left" routerLink="/addCompany"></button>
        </div>
    </div>
</div>

<div style="padding-top:72px;">
    <div class="p-white shadow m-3">
        <p-table [value]="products" [autoLayout]="true"  styleClass="p-datatable-striped p-datatable-auto-layout ">


            <ng-template pTemplate="caption">
                <div class="d-flex flex-row justify-content-between">
                    <span class="p-input-icon-left p-ml-auto">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text"  placeholder="Search keyword" />
                    </span>
                    <button pButton label="Clear" class="p-button-outlined" icon="pi pi-filter-slash"></button>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th>Company Name <p-columnFilter type="date" field="name" display="menu"></p-columnFilter></th>
                    <th pSortableColumn="code">Company Code <p-sortIcon field="code"></p-sortIcon></th>
                    <th pSortableColumn="address">Company Address <p-sortIcon field="address"></p-sortIcon></th>
                    <th>Registration Number</th>
                    <th>Vat Number</th>
                    <th>Registered on</th>
                    <th>Created On <p-columnFilter type="date" field="CreatedOn" display="menu"></p-columnFilter></th>
                    <th>Created By<p-columnFilter type="text" field="CreatedBy" display="menu"></p-columnFilter> </th>
                    <th>Is Parent <p-columnFilter type="text" field="isParent" display="menu"></p-columnFilter> </th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product>
                <tr>
                <td><a (click)="visibleSidebar2 = true" >Hayleys Lanka (PVT) LTD</a></td>
                <td>COM181307948</td>
                <td>667 Merry Bear Ramp, New Orleans</td>
                <td>2034750</td>
                <td>4079811</td>
                <td>07/10/2020</td>
                <td>22/09/2020</td>
                <td>Anne Walker</td>
                <td>Yes</td>
                    <!-- <td>{{product.code}}</td>
            <td>{{product.name}}</td>
            <td>{{product.category}}</td>
            <td>{{product.quantity}}</td> -->
            <!-- <td>
                <p-tag styleClass="me-2 mb-1" value="Primary"></p-tag>
                <p-tag styleClass="me-2 mb-1" severity="success" value="Success"></p-tag>
                <p-tag styleClass="me-2 mb-1" severity="warning" value="Warning"></p-tag>
                <p-tag severity="danger" value="Danger"></p-tag>
            </td>
            <td>
                <div class="d-flex flex-column justify-content-end">
                    <div class="d-flex justify-content-end mb-1">
                        <small>10/10 Steps</small>
                    </div>
                    <p-progressBar [value]="10"></p-progressBar>
                </div>
            </td> -->
            <td>
                <!-- <button pButton pRipple type="button" icon="pi pi-check" class="p-button-text"></button> -->
                <button pButton pRipple type="button" icon="pi pi-pencil" class="p-button-success p-button-text"></button>
                <button pButton pRipple type="button" icon="pi pi-trash" class="p-button-danger p-button-text"></button>
            </td>
                </tr>
            </ng-template>
        </p-table>
        <div class="d-flex justify-content-end">
           
            <p-paginator [rows]="10" [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [rowsPerPageOptions]="[10,20,30]"></p-paginator>
        </div>

        </div>
</div>


<p-sidebar [(visible)]="visibleSidebar2" position="right" [baseZIndex]="10000">
    <div class="d-flex flex-row align-items-center mb-5">
        <h4 class="my-0">Hayleys Lanka </h4>
        <p-tag class="ms-2" value="Parent Company"></p-tag>
    </div>
    <div class="d-flex flex-column mb-4">
        <p class="my-0"><b>Company Code</b></p>
        <p class="mt-2 mb-0">COM181307948</p>
    </div>
    <div class="d-flex flex-column mb-4">
        <p class="my-0"><b>Company Registration Number </b></p>
        <p class="mt-2 mb-0">2034750</p>
    </div>
    <div class="d-flex flex-column mb-4">
        <p class="my-0"><b>Vat Number </b></p>
        <p class="mt-2 mb-0">4079811</p>
    </div>
    <div class="d-flex flex-column mb-4">
        <p class="my-0"><b>Company Registered date </b></p>
        <p class="mt-2 mb-0">07/10/2020</p>
    </div>
    <div class="d-flex flex-column mb-4">
        <p class="my-0"><b>Address</b></p>
        <p class="mt-2 mb-0">667 Merry Bear Ramp, New Orleans</p>
    </div>
    <div class="d-flex flex-column mb-4">
        <p class="my-0"><b>City</b></p>
        <p class="mt-2 mb-0">Colombo</p>
    </div>
    <div class="d-flex flex-column mb-4">
        <p class="my-0"><b>State</b></p>
        <p class="mt-2 mb-0">Western Province</p>
    </div>
    <div class="d-flex flex-column mb-4">
        <p class="my-0"><b>Postal Code *</b></p>
        <p class="mt-2 mb-0">10250</p>
    </div>
    <div class="d-flex flex-column mb-4">
        <p class="my-0"><b>Country</b></p>
        <p class="mt-2 mb-0">Sri Lanka</p>
    </div>
    <div class="d-flex flex-column mb-4">
        <p class="my-0"><b>Operational Group(s)</b></p>
        <p class="mt-2 mb-0">Admin, Super Admin</p>
    </div>
    
</p-sidebar>